import { render, staticRenderFns } from "./AllowSubscription.vue?vue&type=template&id=158875be&scoped=true&"
import script from "./AllowSubscription.vue?vue&type=script&lang=js&"
export * from "./AllowSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158875be",
  null
  
)

export default component.exports